import React, { useEffect, useRef, useState } from 'react';
import moment from "moment";
import { RiDeleteBin2Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import toast from 'react-hot-toast';
import Page from "../../Components/Page";
import DatePicker from "react-datepicker";
import { editData, addData, getData } from "../../controllers/studentEventsEdit.controller"

import { useLocation, useParams } from "react-router-dom";
import StudentEvents from './StudentEvents';
import { useNavigate } from "react-router-dom";
import { addEventImages, deleteEventImage } from '../../controllers/studentEvents.controller';


const StudentEventsEdit = () => {
    const [image, setImage] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [data, setData] = useState([]);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [imageData, setImageData] = useState([])

    const navigate = useNavigate();


    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImage(URL.createObjectURL(file));
            //setImage(file)
            setSelectedFile(file)
        } else setSelectedFile(null)

    };

    // const handleImageChange = (event) => {
    //     const file = event.target.files[0];
    //     handleFileSelected(file);
    // };


    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        handleFileSelected(file);
    };


    const handleFileSelected = (file) => {
        if (file) {
            if (file.size > 1024 * 1024) {  // 1MB limit
                toast.error("File size exceeds 1MB.");
                return;
            }
            setImage(URL.createObjectURL(file));
            setSelectedFile(file);
        } else {
            setSelectedFile(null);
        }
    };

    const removeImage = () => {
        setImage(null);
        setSelectedFile(null);
    }

    const location = useLocation();
    const { id } = useParams();
    const item = location.state?.item;
    useEffect(() => {
        console.log('item => ', item)
        if (item) {
            setFormData({
                event_id: item.event_id || null,
                event_name: item.event_name || "",
                date: item.date || null, // Changed to null
                location: item.location || "",
                file: item.file || "",
                description: item.description || "",
            });
            setImageData(item.images.map((img, i) => ({...img, dataId: i})) || [])
        }
    }, [item]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };



    const handleSubmit = (e) => {
        e.preventDefault();

    };

    const [formData, setFormData] = useState({
        event_id: null,
        event_name: "",
        description: "",
        date: null, // Initialized to null
        location: "",
        file: null,

    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };


    const formatISODateForInput = (date) => {
        if (!date) return '';
        try {
            return moment(date).format('YYYY-MM-DDTHH:mm');
        } catch (error) {
            console.error("Error formatting date:", error);
            return '';
        }
    };




    // Add





    const handleRemoveImage = () => {
        setImage(null); // Reset the image state
    };



    console.log('selected file => ', selectedFile)

    const addImageData = async () => {
        try {
            const imageList = [...imageData];
            console.log('imageList => ', imageList)
            imageList.push({
                dataId: imageList.length,
                image_path: selectedFile?.name,
                image_url: image,
                file: selectedFile,
                isTemp: true
            })
            setImageData(imageList)
            setImage(null)
            setSelectedFile(null)
        } catch (error) {
            console.error("Error", error);
        }
    };

    const deleteImage = () => {
        try {
            const imageList = [...imageData];
            console.log('imageList => ', imageList)
            const imageObj = imageList[selectedRowId]
            if (imageObj.isTemp) imageList.splice(selectedRowId, 1);
            else imageObj.isDeleted = true
            setImageData(imageList)
            setSelectedRowId(null)
            document.getElementById("modal-delete").close()
        } catch (error) {
            console.error("Error", error);
        }
    }

    const saveBtn = async () => {
        try {
            const { event_id, event_name, date, location, description, } = formData;

            if (!event_name || !date || !location || !description) {
                toast.error("Please fill in all the required fields and upload a document.");
                return;
            }

            toast.loading("Submitting your data...");

            const addedFiles = imageData.filter((d) => d.isTemp).map((d) => d.file);
            const deletedFiles = imageData.filter((d) => d.isDeleted).map((d) => d.image_id);


            //console.log('added files => ', addedFiles, ' => ', deletedFiles)


            const mainDataUpdate = editData({
                id: event_id,
                event_name,
                date: moment(date).format("YYYY-MM-DD HH:mm:ss"), // Changed Date format
                location,
                description,
            });

            const addImagePromises = addedFiles.map((file) => addEventImages({ id: event_id, file }))
            const deleteImagePromises = deletedFiles.map((imageId) => deleteEventImage({id: imageId}))

            const res = await Promise.all([mainDataUpdate, ...addImagePromises, ...deleteImagePromises])

            //console.log('promise res = > ', res)
            toast.dismiss();
            if(res.every((d) => d.status === 200)){
                const message = res[0].data.message;
                toast.success(message);
                navigate('/sab/student-events')
            } else {
                toast.error("Failed to update some event data.");
            }
        } catch (error) {
            toast.dismiss();
            console.error("Error adding research data:", error);
            const message = error?.response?.data?.message || "Something went wrong!";
            toast.error(message);
        }
    };

    return (
        <div>

            <Page className="px-8 py-6">

                <div className="p-6">

                    <div className='flex items-center gap-10 text-xl'>
                        <div className="text-[#4B465C] ">
                            Research & Student Life / Student Life / <hi className="text-[black] bg-white mt-6"> Student Events</hi>
                        </div>
                    </div>

                    <div className="container">
                        <div className="p-6 mx-auto bg-white rounded-lg shadow-md">


                            <form onSubmit={handleSubmit}>
                                <h1 className="mb-4 text-xl font-bold text-gray-700">Edit Events </h1>


                                <div className="w-full mb-4 text-left">
                                    <div className="p-6">

                                        <form onSubmit={(e) => e.preventDefault()}>
                                            <div className="flex items-start gap-6">
                                                {/* Event Name Input */}
                                                <div className="flex-1">
                                                    <label htmlFor="event_name" className="block mb-2 text-gray-600">
                                                        Event Name
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="event_name"
                                                        name="event_name"
                                                        value={formData.event_name}
                                                        onChange={handleChange}
                                                        className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                                    />
                                                </div>

                                               {/* Date Picker */}
                                                <div className="relative flex-1">
                                                    <label className="block mb-2 text-gray-600" htmlFor="date-picker">
                                                        Date
                                                    </label>
                                                    <input
                                                        id="date-picker"
                                                        name="date"
                                                        type="datetime-local"
                                                        value={formData.date ? formatISODateForInput(formData.date) : ''}
                                                        onChange={(e) => {
                                                            setFormData({ ...formData, date: e.target.value });
                                                        }}
                                                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                                                    />
                                                </div>


                                            </div>



                                            <div className="mb-4">
                                                <label htmlFor="location" className="block text-sm font-medium text-gray-700">
                                                    Location
                                                </label>
                                                <input
                                                    id="location"
                                                    name="location"
                                                    value={formData.location}
                                                    onChange={handleChange}
                                                    className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                                />
                                            </div>

                                            <div className="mb-4">
                                                <label htmlFor="description" className="block text-sm font-medium text-gray-700">
                                                    Description
                                                </label>
                                                <textarea
                                                    id="description"
                                                    name="description"
                                                    value={formData.description}
                                                    onChange={handleChange}
                                                    rows="4"
                                                    className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                                />
                                            </div>


                                        </form>
                                    </div>
                                </div>


                                <div className="">

                                    <div className="justify-between mb-6">
                                        <h1 className="block text-black font-medium mb-2 text-[18px]" htmlFor="welcomeMessage">
                                            Logo <b className="text-[#4B465C]">(Accept: .jpg, .png)</b>
                                        </h1>
                                        <div className="grid grid-cols-2 gap-6 ">
                                            <div className="flex flex-col items-center justify-center h-48 mt-2 border-2 border-gray-300 border-dashed rounded-lg" onDragOver={handleDragOver} onDrop={handleDrop}>
                                                {image ? (

                                                    <>
                                                        <img src={image}
                                                             alt="Uploaded Preview"
                                                             className="object-contain w-auto h-28" />
                                                        <div className="flex flex-row gap-3">
                                                            <button className='px-4 py-2 text-[#eb372e] rounded-md cursor-pointer border-2 border-[#eb372e] hover:bg-[#eb372e] hover:text-white' onClick={handleRemoveImage}>
                                                                Remove Image
                                                            </button>
                                                            <button className='px-4 py-2 text-white rounded-md cursor-pointer border-2 border-[#92288C] bg-[#92288C] hover:bg-[#92288C] hover:text-white' onClick={() => addImageData()}>
                                                                Add Image
                                                            </button>
                                                        </div>

                                                    </>
                                                ) : (
                                                    <div className="text-gray-500">
                                                        <div className="flex justify-center">
                                                            <svg
                                                                xmlns="testing imgage"
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                                strokeWidth={1.5}
                                                                stroke="currentColor"
                                                                className="w-10 h-10"
                                                            >
                                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                                                            </svg>
                                                        </div>
                                                        <p>Drag and drop image here</p>
                                                        <p>or</p>
                                                        <div className='flex gap-10'>
                                                            <label className="px-4 py-2 text-[#92288C] rounded-md cursor-pointer border-2 border-[#92288C] hover:bg-[#92288C] hover:text-white">
                                                                <input
                                                                    type="file"
                                                                    accept=".jpg, .png"
                                                                    onChange={handleImageChange}
                                                                    className="hidden"
                                                                />
                                                                Browse image
                                                            </label>

                                                        </div>
                                                    </div>
                                                )}



                                            </div>


                                            <div>




                                                <div className="p-6 mx-auto bg-white rounded-lg ">


                                                    <table className="w-full bg-white border-collapse rounded-lg shadow-md">
                                                        <thead>
                                                        <tr className="bg-gray-100 text-[#4B465C]">
                                                            <th className="w-1/4 px-4 py-2 text-center">Preview</th>
                                                            <th className="w-1/4 px-4 py-2 text-center">File Name</th>

                                                            <th className="w-1/4 px-4 py-2 text-center">Actions</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {imageData.filter((d) => !d.isDeleted).map((img, index) => (
                                                            <tr key={index} className="border-b hover:bg-gray-50">

                                                                <td className="px-4 py-2 text-center">
                                                                    <div className="w-16 h-16 mx-auto overflow-hidden bg-gray-200 rounded-md">
                                                                        <img
                                                                            src={img.image_url} // including a image
                                                                            alt={`Preview ${index + 1}`}
                                                                            className="object-cover w-full h-full"
                                                                        />
                                                                    </div>
                                                                </td>


                                                                <td className="px-4 py-2 text-center">{img.image_path}</td>
                                                                {/* <td className="px-4 py-2 text-center">{formData.file ? formData.file.name || formData.file : ""}</td> */}


                                                                <td className="px-4 py-2 text-center">
                                                                    <div className="flex justify-center gap-4">
                                                                        <button
                                                                            onClick={() => {
                                                                                setSelectedRowId(img.dataId)
                                                                                document.getElementById("modal-delete").showModal();
                                                                            }}
                                                                            className="flex items-center px-3 py-1 bg-[#A8AAAE14] text-[#A8AAAE] border border-[#A8AAAE] rounded-md hover:bg-gray-300"
                                                                        >
                                                                            Delete
                                                                            <RiDeleteBin2Line className="ml-2" />
                                                                        </button>


                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    </table>



                                                </div>

                                            </div>
                                        </div>
                                    </div>


                                </div>



                                <div className="flex justify-end space-x-4">
                                    <button
                                        type="button"
                                        className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md"
                                        onClick={() => {

                                            navigate('/sab/student-events')
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        onClick={saveBtn}
                                        className="px-4 py-2 bg-[#92288C] text-white rounded-md"
                                    >
                                        Save
                                    </button>
                                </div>


                            </form>
                        </div>




                        <dialog
                            id="modal-delete"
                            className="inset-0 z-50 rounded-lg modal modal-bottom sm:modal-middle"
                        >

                            <div className="relative z-10 w-full max-w-lg p-6 mx-auto bg-white rounded-lg shadow-lg">
                                <div className="text-center">
                                    <h2 className="text-xl font-bold text-gray-900">
                                        Delete
                                    </h2>
                                    <p className="font-bold text-gray-500">
                                        Are you sure?
                                    </p>
                                </div>


                                <div className="flex justify-center mt-4 space-x-4">
                                    <button
                                        onClick={() => {
                                            setSelectedRowId(null)
                                            document.getElementById("modal-delete").close()
                                        }}
                                        className="px-6 py-3 text-gray-600 transition bg-gray-200 rounded-lg hover:bg-gray-200 active:scale-95 hover:shadow-lg"
                                    >
                                        No
                                    </button>
                                    <button
                                        onClick={() => deleteImage()}
                                        className="rounded-lg transition active:scale-95 hover:shadow-lg px-6 py-3 bg-[#92288C] text-white"
                                    >
                                        Yes
                                    </button>
                                </div>
                            </div>
                        </dialog>





                    </div>
                </div>


            </Page>
        </div>

    )
}

export default StudentEventsEdit